import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface propsInterface {
    /** `admin` : aligné sur le padding du contenu de LCContainer, texte gris. */
    variant?: "admin";
}

export default function Footer({ variant }: propsInterface) {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={variant === "admin" ? "footer-admin" : undefined}>
            <Box
                className="footer-container"
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: { xs: "center", sm: "space-between" },
                }}
            >
                <Typography>
                    ©{currentYear} - Tous droits réservés Lien Citoyen
                </Typography>
                <Typography sx={{}}>
                    <a href="/politique-confidentialite">
                        Politique de confidentialité
                    </a>
                </Typography>
                <Typography sx={{}}>
                    Une application{" "}
                    <b>
                        <a
                            href="https://cognitif.ca/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            cognitif
                        </a>
                    </b>
                </Typography>
            </Box>
        </footer>
    );
}
